<template>
    <div class="bg-white rounded box-shadow p-3 mb-1" style="padding-bottom:1px!important">
        <div class="row">
            <div v-if="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                <span v-for="(err, index) in validation_errors" :key="index">
                  {{ err[0] }} <br />
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-9">
                <h5 class="float-left">11 If yes, Give detailed information:</h5>
            </div>
            <div class="col-md-3 float-right">
                <b-button v-b-modal.land-buy-modal type="button"
                          @click="resetForm(),$bvModal.show('land-buy-modal')"
                          class="btn btn-success float-right btn-sm mb-1 text-black float-right">
                    Add Land Buy
                    <i class="fas fa-plus"></i>
                </b-button>
            </div>
        </div>

        <div class="scrollable-table">
            <table class="table table-centered table-striped">
                <thead>
                <tr>
                    <th>SL</th>
                    <th>Land Type</th>
                    <th>Mouza</th>
                    <th>Plot</th>
                    <th>Land Amount</th>
                    <th>Document No and Date</th>
                    <th>Stamp Fee</th>
                    <th>Registration Fee</th>
                    <th>Total(Taka)</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(land_buy, index) in land_buys" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ land_buy.land_type.land_type_desc }}</td>
                    <td>{{ land_buy.land_mouza }}</td>
                    <td>{{ land_buy.plot }}</td>
                    <td>{{ land_buy.land_amount }}</td>
                    <td>{{ land_buy.document_no }} & {{ land_buy.date }}</td>
                    <td>{{ land_buy.stamp_fee }}</td>
                    <td>{{ land_buy.registration_fee }}</td>
                    <td> {{ result(land_buy.stamp_fee,land_buy.registration_fee) }}</td>
                    <td>
                        <b-button variant="warning"
                                  class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                                  @click.prevent="getLandBuy(land_buy), $bvModal.show('land-buy-modal')">
                            <i class="far fa-edit"></i></b-button>
                        <b-button variant="danger"
                                  class="btn btn-warning btn-xs waves-effect waves-light"
                                  @click.prevent="softDelete(land_buy.id)"><i
                                class="far fa-trash-alt"></i></b-button>
                    </td>
                </tr>
                </tbody>
            </table>
          <div v-if="loader" class="loader">Loading...</div>
            <h5 v-if="land_buys.length === 0" class="text-center text-secondary">
                No Data Found
            </h5>
        </div>

        <land-buy-modal
                :land_buy="land_buy"
                :btn_edit="btn_edit"
                @getPersonLandBuys="getPersonLandBuys"
                @resetForm="resetForm"
        ></land-buy-modal>
    </div>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import LandBuyModal from "../../modals/LandBuyModal";

    export default {
        page: {
            title: "Search Land",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, LandBuyModal},
        data() {
            return {
                title: "Search Land",
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Search',
                        active: true,
                    },
                ],
                land_buys: {},
                land_buy: {},
                btn_edit: false,
                validation_errors: {},
                show: false,
                loader: false
            };
        },

        mounted() {
            this.land_buy.ses_id = this.$route.params.ses_id;
            this.getPersonLandBuys();
        },

        methods: {
             result(stamp_fee, registration_fee)  {
                 return parseInt(stamp_fee) + parseInt(registration_fee);
            },
            async getLandBuy(land_buy) {
                this.land_buy = {};
                this.btn_edit = true;
                // this.land_alternative = land_alternative;
                await http.get("api/land-buys/" + land_buy.id + "/edit").then(response => {
                    if (!response.error) {
                        this.land_buy = response.data.land_buy;
                    }
                });
            },
            softDelete(land_buy_id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/land-buys/" + land_buy_id).then(response => {
                        if (!response.error) {
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                            this.getPersonLandBuys();
                        } else {
                            this.$bvToast.toast("Deleted Failed", {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }
                    });
                }
            },
            getPersonLandBuys() {
                this.loader = true
                 http.get("api/land-buy/getPersonLandBuy/" + this.land_buy.ses_id)
                    .then(response => {
                        if (!response.error) {
                            this.loader = false
                            this.land_buys = response.data.land_buys;
                        }
                    });
            },
            resetForm() {
                this.btn_edit = false;
                this.land_buy = {};
                this.land_buy.ses_id = this.$route.params.ses_id;
            },
        },
    };
</script>
